export const checkSubOptions = sideBarOptions => {
  let i = 0;
  for (i; i < sideBarOptions.length; i += 1) {
    if (sideBarOptions[i].options && sideBarOptions[i].options.length === 1) {
      sideBarOptions[i].linkTo = sideBarOptions[i].options[0].linkTo;
    }
  }
  return sideBarOptions;
};
